import React from 'react';
import { Link } from '@ipc/ipc-core';

const LinkToWrapper = (to, { children }) => (
  <Link to={to.toString()}>
    {children}
  </Link>
);

export default LinkToWrapper;
